const DURATION = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
};

const MERGE_PRODUCT_DURATION = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

const PACKAGE_EXPIRES = {
  MONTHLY: 30,
  QUARTERLY: 90,
  YEARLY: 365,
};

const PACKAGE_DURATION_LABEL = {
  MONTHLY: 'monthlyPackage',
  QUARTERLY: 'quarterlyPackage',
  YEARLY: 'yearlyPackage',
};

const PACKAGE_DURATION = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
};

const PACKAGE_STATUS = {
  USING: 'USING',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  CANCEL: 'CANCEL',
  PAID: 'PAID',
};

const ORDER_STATUS = {
  PENDING: 'PENDING',
  CANCEL: 'CANCEL',
  PAID: 'PAID',
  WAITING_FOR_ACTIVATION: 'WAITING_FOR_ACTIVATION',
};

const FREE_PACKAGE_CODES = [
  'STUDIO-TRIAL',
  'STUDIO-BASIC',
  'STUDIO-FREE',
  'DUBBING-BASIC',
  'DUBBING-TRIAL',
  'STUDIO-FREE-V2',
  'STUDIO-FREE-V3',
];

const PACKAGE_LEVEL = {
  TRIAL: 'TRIAL',
  BASIC: 'BASIC',
  ADVANCE: 'ADVANCE',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
  PROFESSIONAL: 'PROFESSIONAL',
  STANDARD: 'STANDARD',
  SPECIAL: 'SPECIAL',
  allPackages: 'allPackages',
  DUBBING_BASIC: 'DUBBING-BASIC',
  DUBBING_TRIAL: 'DUBBING-TRIAL',
  BUSINESS: 'BUSINESS',
  VIP: 'VIP',
  CUSTOM: 'CUSTOM',
};

const PACKAGE_CODE_ALL = {
  TRIAL: 'TRIAL',
  BASIC: 'BASIC',
  ADVANCE: 'ADVANCE',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
  PROFESSIONAL: 'PROFESSIONAL',
  STANDARD: 'STANDARD',
  SPECIAL: 'SPECIAL',
  API_ADVANCE: 'ADV',
  API_PREMIUM: 'PREMIUM',
  VIP: 'VIP',
};

// old package that will be change name
const MIGRATED_NAME_PACKAGE_CODES = {
  'STUDIO-STANDARD-QUARTERLY': 'STUDIO-STANDARD-MONTH-V3',
  'STUDIO-STANDARD-QUARTERLY-AUTO-RENEW': 'STUDIO-STANDARD-MONTH-V3',
  'STUDIO-PROFESSIONAL-MONTH': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PROFESSIONAL-MONTH-AUTO-RENEW': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PROFESSIONAL-QUARTERLY': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PROFESSIONAL-QUARTERLY-AUTO-RENEW': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PROFESSIONAL-YEAR': 'STUDIO-SPECIAL-YEAR-V3',
  'STUDIO-PROFESSIONAL-YEAR-AUTO-RENEW': 'STUDIO-SPECIAL-YEAR-V3',
  'STUDIO-PROFESSIONAL-MONTH-V2': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PROFESSIONAL-YEAR-V2': 'STUDIO-SPECIAL-YEAR-V3',
  'STUDIO-ADV-MONTH': 'STUDIO-STANDARD-MONTH-V3',
  'STUDIO-ADV-YEAR': 'STUDIO-STANDARD-YEAR-V3',
  'STUDIO-PRO-MONTH': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PRO-QUARTERLY': 'STUDIO-SPECIAL-MONTH-V3',
  'STUDIO-PRO-YEAR': 'STUDIO-SPECIAL-YEAR-V3',
};

const AFFILIATE_PACKAGE_CODE_LEVEL = {
  TRIAL: 'TRIAL',
  BASIC: 'BASIC',
  PRO: 'PRO',
  ENTERPRISE: 'ENTERPRISE',
  PROFESSIONAL: 'PROFESSIONAL',
  allPackages: 'allPackages',
  ADV: 'ADVANCE',
};

const PACKAGE_TYPE = {
  STUDIO: 'STUDIO',
  API: 'API',
  ARTICLE: 'ARTICLE',
  CHARACTER: 'CHARACTER',
  DUBBING: 'DUBBING',
  CLONING: 'CLONING',
  STT: 'STT',
};

const FEATURE = {
  VIETNAM_VOICE: 'vietnam-voice',
  GLOBAL_VOICE: 'global-voice',
  BASIC_GLOBAL_VOICE: 'basic-global-voice',
  ADVANCED_GLOBAL_VOICE: 'advanced-global-voice',
  TTS_BY_SENTENCE: 'tts-by-sentences',
  TTS_BY_SSML: 'tts-by-ssml',
  TTS_BY_FILE: 'tts-by-file',
  TTS_BY_URL: 'tts-by-url',
  FREE_TRIAL: 'free-trial',
  VOICE_EFFECT: 'voice-effect',
  EMPHASIS: 'emphasis',
  PREVIEW: 'preview',
  CLIENT_PAUSE: 'client-pause',
  INVOICE: 'invoice',
  STREAMING_PREVIEW: 'streaming-preview',
  SUBTITLE: 'subtitle',
  CUSTOMIZATION_PRONUNCIATION: 'customization-pronunciation',
  INPUT_TXT: 'input-txt',
  INPUT_DOC: 'input-doc',
  INPUT_PDF: 'input-pdf',
  INPUT_SRT: 'input-srt',
  INPUT_URL: 'input-url',
  INPUT_IMAGE: 'input-image',
  OUTPUT_MP3: 'output-mp3',
  OUTPUT_WAV: 'output-wav',
  OUTPUT_SRT: 'output-srt',
  OUTPUT_MP4: 'output-mp4',
  AI_DUBBING: 'ai-dubbing',
  AI_VOICE_CLONING: 'ai-voice-cloning',
  AI_INSTANT_VOICE_CLONING: 'ai-instant-voice-cloning',
  AI_SPELLING_CHECKING: 'ai-spelling-checking',
  AI_REWRITING: 'ai-rewriting',
  AI_TRANSLATION: 'ai-translation',
  AI_GRAMMAR_CHECKING: 'ai-grammar-checking',
  AI_CUSTOMIZATION_PRONUNCIATION: 'ai-customization-pronunciation',
  TTS_API: 'tts-api',
  AI_REWRITE: 'ai-rewrite',
  AI_GENERATE_NARRATION: 'ai-generate-narration',
  TRANSCRIPT_DUBBING: 'transcript-dubbing',
};

const LIMITED_PREVIEW_PACKAGE_LEVEL = ['TRIAL'];

const PACKAGE_CODE = {
  API_PAYG: 'API-PAYG',
  API_ENTERPRISE_YEAR_V2: 'API-ENTERPRISE-YEAR-V2',
  STUDIO_TRIAL: 'STUDIO-TRIAL',
  STUDIO_FREE: 'STUDIO-FREE',
  STUDIO_FREE_V2: 'STUDIO-FREE-V2',
  STUDIO_FREE_V3: 'STUDIO-FREE-V3',
  STUDIO_BASIC: 'STUDIO-BASIC',
  DUBBING_TRIAL: 'DUBBING-TRIAL',
  STUDIO_ENTERPRISE_YEAR_V2: 'STUDIO-ENTERPRISE-YEAR-V2',
};

const PRODUCT_TYPE = {
  aivoiceStudio: 'STUDIO',
  aivoiceApi: 'API',
  aivoiceDubbing: 'DUBBING',
};

const MERGE_PRODUCT_TYPE = {
  aivoiceStudio: 'AIVOICE_STUDIO',
  aivoiceApi: 'AIVOICE_API',
};

const PREFIX_AUTO_RENEW = 'AUTO-RENEW';

const PACKAGE_STUDIO_VERSION = {
  V1: 'V1',
  V2_1: 'V2.1',
  V2: 'V2',
  V3: 'V3',
};

const BUSINESS_PACKAGE_CODES = ['API-BUSINESS', 'STUDIO-BUSINESS'];

const PACK_DURATION = {
  YEAR: 360,
  MONTH: 30,
  INFINITE: -1,
};

const PACKAGE_LEVEL_V3 = {
  STANDARD: 'STANDARD',
  SPECIAL: 'SPECIAL',
  VIP: 'VIP',
  CUSTOM: 'CUSTOM',
};

const TYPE_POPUP_MIGRATE = {
  TYPE_V3_UP_DOWN_GRADE: 'TYPE-V3-UP-DOWN-GRADE',
  TYPE_V3_SAME_LEVEL: 'TYPE_V3_SAME_LEVEL',
  TYPE_MIGRATE_V1_V2_TO_V3: 'TYPE-MIGRATE-V1-V2-TO_V3',
};

const PACKAGE_CODE_V3 = {
  STUDIO_STANDARD_MONTH_V3: 'STUDIO-STANDARD-MONTH-V3',
  STUDIO_SPECIAL_MONTH_V3: 'STUDIO-SPECIAL-MONTH-V3',
  STUDIO_STANDARD_YEAR_V3: 'STUDIO-STANDARD-YEAR-V3',
  STUDIO_SPECIAL_YEAR_V3: 'STUDIO-SPECIAL-YEAR-V3',
  STUDIO_SPECIAL_TOPUP_V3: 'STUDIO-SPECIAL-TOPUP-V3',
  STUDIO_VIP_MONTH_V3: 'STUDIO-VIP-MONTH-V3',
  STUDIO_VIP_YEAR_V3: 'STUDIO-VIP-YEAR-V3',
  STUDIO_CUSTOM_YEAR_V3: 'STUDIO-CUSTOM-YEAR-V3',
  STUDIO_VIP_MONTH_V3_1: 'STUDIO-VIP-MONTH-V3.1',
  STUDIO_VIP_YEAR_V3_1: 'STUDIO-VIP-YEAR-V3.1',
  STUDIO_CUSTOM_YEAR_V3_1: 'STUDIO-CUSTOM-YEAR-V3.1',
};

const TOP_UP_PACKAGE_CODES = [
  'STUDIO-STANDARD-TOPUP-V3',
  'STUDIO-SPECIAL-TOPUP-V3',
  'STUDIO-VIP-TOPUP-V3',
];

const PACKAGE_CHANGE_TYPES = {
  SAME_LEVEL: 'same_level',
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
};

const VERISON_PACKAGE = {
  V3: 'V3',
  V2_1: 'V2.1',
};

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;

const RESOURCES_TYPE = {
  CREDITS: 'credits',
  DEVICES: 'devices',
  VOICE_CLONINGS: 'voiceClonings',
  CONCURRENT_REQUEST_API: 'concurrentRequestApi',
};

const CURRENCY_UNIT = {
  VND: 'VND',
  USD: 'USD',
};

const PACKAGE_HAS_EOL = [
  'STUDIO-BUSINESS',
  'STUDIO-ENTERPRISE-YEAR-V2',
  'STUDIO-ENTERPRISE-YEAR',
  'STUDIO-PROFESSIONAL-YEAR-V2',
  'STUDIO-PROFESSIONAL-YEAR',
  'STUDIO-PRO-MONTH',
  'STUDIO-ENTERPRISE-YEAR-V2.1',
  'STUDIO-ENTERPRISE-MONTH',
  'STUDIO-PROFESSIONAL-MONTH-V2',
  'STUDIO-PROFESSIONAL-MONTH',
  'STUDIO-PRO-YEAR',
  'STUDIO-ENTERPRISE-MONTH-V2.1',
  'STUDIO-ENTERPRISE-MONTH-V2',
  'STUDIO-PRO-QUARTERLY',
  'STUDIO-PROFESSIONAL-QUARTERLY',
  'STUDIO-PROFESSIONAL-YEAR-AUTO-RENEW',
  'STUDIO-PROFESSIONAL-QUARTERLY-AUTO-RENEW',
  'STUDIO-PROFESSIONAL-MONTH-AUTO-RENEW',
];

const CONTENT_MIN = 1;
const CONTENT_MAX = 50;
const WORD_MIN = 300;
const WORD_MAX = 9000;
const WORD_STEP = 150;
const WORD_PER_PAGE = 650;
const WORDS_PER_MINUTE = 150;

const LOW_CREDITS = {
  FREE_PACKAGE: 500,
  PAID_PACKAGE: 5000,
};

const PACKAGE_FEATURES = {
  ADVANCED_VIETNAM_VOICE: 'advanced-vietnam-voice',
  ADVANCED_GLOBAL_VOICE: 'advanced-global-voice',
  PREMIUM_VIETNAM_VOICE: 'premium-vietnam-voice',
  PREMIUM_GLOBAL_VOICE: 'premium-global-voice',
  AI_CUSTOMIZATION_PRONUNCIATION: 'ai-customization-pronunciation',
};

const PACKAGE_LEVEL_ORDER = ['BASIC', 'STANDARD', 'SPECIAL', 'VIP', 'CUSTOM'];

export {
  VERISON_PACKAGE,
  MILLISECONDS_IN_DAY,
  PACKAGE_CHANGE_TYPES,
  TYPE_POPUP_MIGRATE,
  TOP_UP_PACKAGE_CODES,
  PACKAGE_CODE_V3,
  PACK_DURATION,
  DURATION,
  MERGE_PRODUCT_DURATION,
  PACKAGE_EXPIRES as PACKAGE_EXPIRED,
  PACKAGE_DURATION_LABEL,
  PACKAGE_STATUS,
  FREE_PACKAGE_CODES,
  PACKAGE_LEVEL,
  PACKAGE_TYPE,
  FEATURE,
  LIMITED_PREVIEW_PACKAGE_LEVEL,
  PACKAGE_CODE,
  MIGRATED_NAME_PACKAGE_CODES,
  PACKAGE_DURATION,
  AFFILIATE_PACKAGE_CODE_LEVEL,
  ORDER_STATUS,
  PRODUCT_TYPE,
  MERGE_PRODUCT_TYPE,
  PREFIX_AUTO_RENEW,
  BUSINESS_PACKAGE_CODES,
  PACKAGE_STUDIO_VERSION,
  PACKAGE_CODE_ALL,
  PACKAGE_LEVEL_V3,
  RESOURCES_TYPE,
  PACKAGE_HAS_EOL,
  CONTENT_MIN,
  CONTENT_MAX,
  WORD_MIN,
  WORD_MAX,
  WORD_STEP,
  WORD_PER_PAGE,
  WORDS_PER_MINUTE,
  LOW_CREDITS,
  CURRENCY_UNIT,
  PACKAGE_FEATURES,
  PACKAGE_LEVEL_ORDER,
};
